import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, } from 'ionic-angular';
import moment from 'moment';
import { HttpProvider } from '../../providers/http/http';
import { TabsPage } from '../tabs/tabs';
import { Tabs2Page } from '../tabs2/tabs2';

/**
 * Generated class for the ResumenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-resumen',
  templateUrl: 'resumen.html',
})
export class ResumenPage {
  loadModal: any
  facturas: any = [];
  resumen: any = null;
  moneda: any = 'USD'
  super: any = false
  mostrar: any = "SI"
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public http : HttpProvider,
    public alertCtrl: AlertController
    ) {
  }

  transform(value) {
    if(value){
      let val = value
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  transform2(item) {
    let value = (parseFloat(item.vencidas) + parseFloat(item.sin_vencer)).toFixed(2)
    if(value){
      let val = parseFloat(value).toFixed(2).split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  aceptar() {
    window.localStorage.setItem('resumen', moment().format('DD-MM-YYYY').toString())
    window.localStorage.setItem('showMenuResumen', "SI")
    if (this.super) {
      this.navCtrl.setRoot(TabsPage)
    } else {
      this.navCtrl.setRoot(Tabs2Page)
    }
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  ionViewDidEnter() {
    this.mostrar = window.localStorage.getItem('showMenuResumen') ? window.localStorage.getItem('showMenuResumen') : "NO"
    if(window.localStorage.getItem('super')){
      this.super = true
    } else this.super = false
    this.updateMoneda()
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      if (!this.super) {
        this.http.get(`factura/resumen?ven=${window.localStorage.getItem('co_ven')}`).subscribe(
          (res:any=[])=>{
            this.DesactivarLoading()
            this.resumen = res
          }, err=>{
            this.DesactivarLoading()
            console.log(err)
            this.alertCtrl.create({
              title: 'Atención',
              subTitle:'No posee conexión a internet, intente nuevamente.',
              buttons:[
                {
                  text:'Aceptar',
                  cssClass:'btnAceptar',
                  handler:()=>{
                  }
                }
              ]
            }).present()
        })
      } else {
        this.http.get(`factura/resumen?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
          (res:any=[])=>{
            this.DesactivarLoading()
            this.resumen = res
          }, err=>{
            this.DesactivarLoading()
            console.log(err)
            this.alertCtrl.create({
              title: 'Atención',
              subTitle:'No posee conexión a internet, intente nuevamente.',
              buttons:[
                {
                  text:'Aceptar',
                  cssClass:'btnAceptar',
                  handler:()=>{
                  }
                }
              ]
            }).present()
        })
      }
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/resumen/resumen.ts